.createPageContainer {
  display: flex;
  flex-direction: column;
  padding: 2rem;
}
.root {
  border-radius: 1rem;
  border: 1px solid var(--static-divider-standard);
  background-color: var(--static-background-standard);
}
.header {
  border-radius: 1rem 1rem 0 0;
  background-color: var(--static-background-weak);
  padding: 0.75rem 1.5rem;
  border-bottom: 1px solid var(--static-divider-standard);
}
.content {
  padding: 1rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
  overflow-x: auto;
}
.col {
  display: flex;
  flex-direction: column;
}
.section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  /* padding-bottom: 1rem; */
}
.sectionTitle {
  font-size: var(--fs-small-heading);
  padding: 0.5rem 0;
}
.rowItemA {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-grow: 1;
}
.rowItemShipFrom {
  align-items: flex-start;
}
.rowItemALabel {
  width: 128px;
}
.rowItemLabelShipForm {
  margin-top: 5px;
}
.rowItemAContent {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
}
.rowItemAContentSubText {
  margin-top: 4px;
  color: var(--static-text-weak);
  font-size: var(--fs-small);
}
.inlineRow {
  font-size: var(--fs-small);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  white-space: nowrap;
  width: auto;
}

.divider {
  height: 1px;
  width: 100%;
  background-color: var(--static-divider-standard);
  margin: 1rem 0;
}
.footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 1.5rem 1.5rem;
}

.createShipLoaderContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 150px;
}

.rightCol {
  border-radius: 10px;
  border: 1px solid var(--static-divider-standard);
  padding: 20px;
}
.ltlOption {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
